<div class="login-container flex d-flex position-relative justify-content-center row mt-2">
    <div class="credentials-container col-12 col-md-6">
        <div class="mt-0 p-5 bg-light">
            <h1 class="login-title card-title mb-3">{{ 'menu.login' | translate }}</h1>
            <form [formGroup]="loginForm" autocomplete="off">
                <div class="mb-1 row">
                    <div class="col-12 col-md-4 col-xl-4">
                        <app-label controlName="key" class="col-form-label">{{ 'login.email' | translate }}</app-label>
                    </div>
                    <div class="col-12 col-md-8 col-xl-8">
                        <input type="email" id="email" formControlName="email" class="form-control" [placeholder]="'login.email' | translate" />
                        <app-field-error-message controlName="email"></app-field-error-message>
                    </div>
                </div>
                <div class="mb-1 row">
                    <div class="col-12 col-md-4 col-xl-4">
                        <app-label controlName="key" class="col-form-label">{{ 'login.password' | translate }}</app-label>
                    </div>
                    <div class="col-12 col-md-8 col-xl-8">
                        <input type="password" id="password" formControlName="password" class="form-control" placeholder="{{ 'login.password' | translate }}" />
                        <app-field-error-message controlName="password"></app-field-error-message>
                    </div>
                </div>
                <div class="mb-1 row justify-content-end">
                    <div class="d-grid gap-2 col-md-3">
                        <button type="submit" [appClickWait]="login" [disabled]="loginButtonDisable" class="btn btn-primary" id="login">
                            {{ 'menu.login' | translate }}
                        </button>
                    </div>
                </div>
                <hr class="border-1 border-top border-dark" />
                <div class="mb-1">
                    <a class="float-end" [routerLink]="['/authentication/forgotpassword']">{{ 'login.forgot_password' | translate }}</a>
                </div>
            </form>
            <div class="p-3">
                <app-html-viewer [type]="type"></app-html-viewer>
            </div>
        </div>
    </div>
    <div class="version">
        <strong>v{{ appVersion }}</strong>
    </div>
</div>
